import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "card w-100 mb-4"
}
const _hoisted_5 = { class: "card-header bg-secondary text-white fw-bold" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { class: "text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question_set, key) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12",
        key: key
      }, [
        (question_set.name !== null)
          ? (_openBlock(), _createElementBlock("h3", {
              key: 0,
              innerHTML: question_set.name,
              class: "col-12 text-center"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (question_set.instructions !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              innerHTML: question_set.instructions,
              class: "col-12 px-5 pt-1 pb-4 text-center fw-bold"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(question_set.display_type == 1 ? 'row px-3' : 'card-columns px-3')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(question_set, (question, k) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(question_set.display_type == 1 ? 'col-12 col-md-6 col-lg-6' : ''),
              key: k
            }, [
              (k !== 'instructions' && k !== 'name' && k !== 'display_type')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, "Question " + _toDisplayString(parseInt(k) + 1), 1),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", {
                        innerHTML: question.question
                      }, null, 8, _hoisted_7),
                      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
                      (question.question_type_id == _ctx.QuestionType.MULTIPLECHOICE || question.question_type_id == _ctx.QuestionType.TRUEFALSE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("span", {
                              class: "text-primary",
                              innerHTML: _ctx.visit_form.responses.filter(response => response.question_id === question.id)[0].answer.answer
                            }, null, 8, _hoisted_9)
                          ]))
                        : _createCommentVNode("", true),
                      (question.question_type_id == _ctx.QuestionType.LONGFILL)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("span", {
                              class: "text-primary",
                              innerHTML: _ctx.visit_form.responses.filter(response => response.question_id === question.id)[0].response
                            }, null, 8, _hoisted_11)
                          ]))
                        : _createCommentVNode("", true),
                      (question.question_type_id == _ctx.QuestionType.LIKERT)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.visit_form.responses.filter(response => response.question_id === question.id)[0].answer.position) + " (" + _toDisplayString(_ctx.visit_form.responses.filter(response => response.question_id === question.id)[0].answer.answer) + ")", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ], 2),
        _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75" }, null, -1))
      ]))
    }), 128))
  ]))
}